import axios from "axios";
import queryString from "query-string";
import { trackPromise } from "react-promise-tracker";
import { get } from "lodash";
import Config from "config";
import { APIFunction, ErrorObjectType } from "./api.d";
import "./interceptors";

export const API_ERROR_MESSAGE_GENERAL = "Oops. Something wrong happened";
export const ERROR_MESSAGE_NO_NETWORK = "ERROR_MESSAGE_NO_NETWORK";

let isOnline: boolean = navigator.onLine;

window.addEventListener("offline", () => {
  isOnline = false;
});

window.addEventListener("online", () => {
  isOnline = true;
});

const clientHeaderDefault = {
  clientAddress: "127.0.0.1",
  clientTime: "20190925053222.939",
  language: "VI",
  deviceId: "WEBLV24H",
  platform: "BIZ_WEB",
  service: "web",
};

const headerOnBodyDefault = {
  clientAddress: "127.0.0.1",
  clientTime: "20190925093222.939",
  language: "VI",
  deviceId: "WEBLV24H",
  platform: "LV24HWEB",
  // Add more
  channelCode: "WEB_LV24_KHDN",
  categoryCode: "D_TRANSFER_EWALLET",
  authorizedMode: 0,
  makerId: "LV24HWEB",
  checkerMode: 0,
  ip: "127.0.0.1",
};

const api: APIFunction = async ({
  functionName = "",
  params = "",
  method = "get",
  headers = {},
  data = {},
  headerOnBody = {},
  cancelTokenSource,
  onUploadProgress,
}) => {
  const moment = Date.now().toString();
  const clientRequest = Math.floor(Math.random() * Date.now()).toString();
  const newParams = queryString.parse(
    queryString.stringify(params as object, { arrayFormat: "comma" })
  );
  try {
    const response = await trackPromise(
      axios({
        method,
        url: Config.API.ROOT_ENDPOINT,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          ...headers,
        },
        params: newParams,
        data: {
          clientHeader: {
            ...clientHeaderDefault,
            clientRequestId: clientRequest,
            zonedClientTime: `${moment}`,
            function: functionName,
          },
          body: {
            header: {
              ...headerOnBodyDefault,
              clientRequestId: clientRequest,
              zonedClientTime: `${moment}`,
              ...(headerOnBody as object),
            },
            ...(data as object),
          },
        },
        cancelToken: cancelTokenSource?.token,
        onUploadProgress,
      })
    );
    // console.log("headerOnBody headerOnBody", headerOnBody);
    return response && response.data;
  } catch (error: any) {
    if (axios.isCancel(error)) throw error;
    const language = localStorage.getItem("language");
    const userMessage =
      get(error, "response.data.userMessage", "") ||
      get(error, "response.data.message", "") ||
      get(error, "response.data.error", "") ||
      get(error, "response.data.body", "") ||
      language === "vi"
        ? "Lỗi kết nối!"
        : "Connection error!";

    const errors: any = get(error, "response.data.errors", null);
    let extraErrorMessage = "";
    if (errors) {
      extraErrorMessage = errors
        .map((err: ErrorObjectType) => {
          return err && err.message;
        })
        .join("<br /> ");
      extraErrorMessage = `<br />${extraErrorMessage}`;
    }

    const response = get(error, "response", {});
    const dataResponse = get(error, "response.data", {});

    if (isOnline) {
      const errObject = {
        ...error,
        response: {
          ...response,
          data: {
            ...dataResponse,
            userMessage: `${userMessage}${extraErrorMessage}`,
          },
        },
      };

      throw errObject;
    } else {
      const offlineResponse = {
        response: {
          data: {
            userMessage:
              language === "vi" ? "Đã ngắt kết nối" : "Disconnected!",
          },
        },
      };

      throw offlineResponse;
    }
  } finally {
    // dome something else
  }
};

export default api;
